// axios
import axios from 'axios'

const domain = "https://2024.apianalytics.srisainadhtransport.in/api/"

// const domain = 'http://localhost:8000/api/'

export default axios.create({
  
  baseURL:domain,
  headers: {'token': localStorage.getItem('sessionToken')}

  
})
